'use client';
import SentryMobileAdapter from './adaptars/Sentry.mobile';
import type {
  MonitoringServiceError,
  MonitoringServiceLevel,
  MonitoringServiceTag,
  MonitoringServiceUserContext,
} from './types/monitoring.types';

export interface IMonitoringService {
  init(): void;
  captureError(error: MonitoringServiceError): void;
  captureMessage(message: string, level?: MonitoringServiceLevel): void;
  addListeners(): void;
  addBaseTags(dataUser: MonitoringServiceUserContext): void;
  removeListeners(): void;
  setUserContext(userContext: MonitoringServiceUserContext): void;
  clearUserContext(): void;
  setTag(tag: MonitoringServiceTag): void;
}

let instance: IMonitoringService;

/* ? Eu coloquei como getMonitoringService retornando a instância e não retornando diretamente a instância,
porque a importação deixa de ser no momento de import,
 e sim somente no momento em que é requisitada no componente. */

export const getMonitoringService = (): IMonitoringService | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  if (!instance) {
    instance = new SentryMobileAdapter();
  }

  return instance;
};
